import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getRecruitingAllQueryOptions } from '@/_pages/recruiting/api-service';

export const Route = createFileRoute('/_private/recruiting/')({
  validateSearch: filterState.parse,
  staticData: {
    isFullWidth: true,
    pageTitle: 'Recruiting',
  },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getRecruitingAllQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
